import { render } from "./donations-page.vue?vue&type=template&id=83b02b60"
import script from "./donations-page.vue?vue&type=script&lang=js"
export * from "./donations-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__